import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Box, IconButton, Switch, Tooltip, Typography } from "@mui/material";
import moment from "moment";
import { getPuzzleTypeById } from "../../pzl_common/PuzzleTypeConstants";

export function getColumns({ onToggleEnabled, onDuplicate, onRemove, duplicatingId, removingId }) {
    return [
        {
            field: "enabled",
            headerName: "Enabled",
            flex: 0.5,
            minWidth: 100,
            renderCell: (params) => (
                <Box onClick={(e) => e.stopPropagation()}>
                    <Switch
                        checked={params.value || false}
                        size="small"
                        onChange={(e) => onToggleEnabled(params.row, e.target.checked)}
                    />
                </Box>
            )
        },
        {
            field: "cron",
            headerName: "Quart Cron",
            flex: 1,
            minWidth: 180,
            renderCell: (params) => (
                <Box sx={{ display: "flex", alignItems: "center", height: "100%", width: "100%" }}>
                    <Tooltip title={params.value || ""}>
                        <Typography variant="body2" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 180 }}>
                            {params.value}
                        </Typography>
                    </Tooltip>
                </Box>
            )
        },
        {
            field: "language",
            headerName: "Language",
            flex: 0.5,
            minWidth: 100
        },
        {
            field: "puzzleType",
            headerName: "Puzzle Type",
            flex: 0.7,
            minWidth: 140,
            valueGetter: (value) => {
                const pt = getPuzzleTypeById(value);
                return pt ? pt.name : value;
            }
        },
        {
            field: "memo",
            headerName: "Memo",
            flex: 0.8,
            minWidth: 140,
            sortable: false,
            renderCell: (params) => {
                const text = params.value == null || params.value === "" ? "" : String(params.value);
                if (!text) {
                    return (
                        <Typography variant="body2" color="text.secondary">
                            —
                        </Typography>
                    );
                }
                return (
                    <Box sx={{ display: "flex", alignItems: "center", height: "100%", width: "100%" }}>
                        <Tooltip title={text}>
                            <Typography variant="body2" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 220 }}>
                                {text}
                            </Typography>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field: "tagBasedCrossword",
            headerName: "Tag-based",
            flex: 0.45,
            minWidth: 100,
            sortable: false,
            renderCell: (params) => (
                <Box sx={{ display: "flex", alignItems: "center", height: "100%", width: "100%" }}>
                    {params.row.puzzleType !== "CROSSWORD" ? (
                        <Typography variant="body2" color="text.secondary">
                            —
                        </Typography>
                    ) : (
                        <Typography variant="body2">{params.value ? "Yes" : "No"}</Typography>
                    )}
                </Box>
            )
        },
        {
            field: "latestPublishedDate",
            headerName: "Latest Published",
            width: 180,
            valueFormatter: (value) => {
                if (!value) return "";
                return moment(value).format("YYYY-MM-DD HH:mm");
            }
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 120,
            sortable: false,
            renderCell: (params) => (
                <Box
                    sx={{ display: "flex", alignItems: "center", height: "100%", gap: 0.25 }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <Tooltip title="Duplicate">
                        <span>
                            <IconButton
                                size="small"
                                aria-label="Duplicate schedule"
                                disabled={duplicatingId === params.row.id || removingId === params.row.id}
                                onClick={() => onDuplicate?.(params.row)}
                            >
                                <ContentCopyIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Remove">
                        <span>
                            <IconButton
                                size="small"
                                color="error"
                                aria-label="Remove schedule"
                                disabled={duplicatingId === params.row.id || removingId === params.row.id}
                                onClick={() => onRemove?.(params.row)}
                            >
                                <DeleteOutlineIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Tooltip>
                </Box>
            ),
        },
    ];
}
